<template>
  <layout-base badge-text="HTB">
    <slot />
  </layout-base>
</template>
